import "./style.css";
import clink_agente from "../../assets/imgs/clink_agente.svg";
import clink_filiale from "../../assets/imgs/clink_filiale.svg";

export const ClinkButton = ({ type = "yes", onClick = () => {}, active = false }) => {
  return (
    <>
      <h4 onClick={onClick} className={`flex-cell clickable clink_yes_no_cell ${active ? "active" : ""}`}>
        {type == "yes" ? (
          <>
            SÌ, <br /> voglio essere contattato
            <img src={clink_agente} />
          </>
        ) : (
          <>
            NO, <br /> voglio andare in una filiale
            <img src={clink_filiale} />
          </>
        )}
      </h4>
    </>
  );
};
